//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Hestia',
  data() {
    return {
      defaultJson:{
        "label9": "肝病",
        "hint1": "包括下列几项标准：\n• 收缩压 < 100 mmHg\n• 伴 HR > 100 bpm\n• 需收治 ICU",
        "hint11": "患者是否存在明确的肝素诱导的血小板减少症（HIT）病史？",
        "hint6": "是否存在需要静脉镇痛药物支持超过 24 小时的剧痛？",
        "label4": "需要氧气",
        "hint5": "是否在抗凝治疗过程中出现的肺栓塞？",
        "label10": "妊娠",
        "label6": "剧痛",
        "label1": "血流动力学不稳定",
        "OutPatientPossible": "可以院外治疗",
        "label11": "明确的 HIT",
        "hint10": "患者是否处于妊娠状态？",
        "hint4": "是否需要超过 24 小时的氧气支持以维持氧饱和度 > 90%？",
        "hint9": "患者是否存在严重的肝损？",
        "label3": "出血情况",
        "label8": "肾衰竭",
        "hint3": "活动性出血或高出血风险，包括：\n• 过去 14 天内胃肠道出血\n• 近期脑卒中（< 4 周）\n• 近期手术（< 2 周）\n• 出凝血异常\n• 血小板减少症（< 75 x 10⁹\/L)\n• 未控制的高血压（收缩压 > 180 mmHg 或舒张压 > 110 mmHg）",
        "hint8": "患者肌酐清除率是否小于 30 mL\/min？",
        "label5": "接收抗凝治疗中",
        "OutpatientNotPossible": "不适宜院外治疗",
        "hint2": "溶栓治疗或栓子清除是否必要？",
        "hint7": "导致院内治疗超过 24 小时的医学或社会原因（感染、恶性肿瘤、缺乏基础支援...）？",
        "label7": "需要住院",
        "label2": "需要栓子碎除"
      },
      form:{
        critera1:'0',
        critera2:'0',
        critera3:'0',
        critera4:'0',
        critera5:'0',
        critera6:'0',
        critera7:'0',
        critera8:'0',
        critera9:'0',
        critera10:'0',
        critera11:'0',
      },
      hasScore:false,
      disabled:false,
      showScore:false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.critera1 + form.critera2 + form.critera3 + form.critera4 + form.critera5 + form.critera6 + form.critera7 + form.critera8 + form.critera9 + form.critera10 + form.critera11
      self.hasScore = true
      return String(result)
      /* if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // critera1 + critera2 + critera3 + critera4 + critera5 + critera6 + critera7 + critera8 + critera9 + critera10 + critera11
        let result = form.critera1 + form.critera2 + form.critera3 + form.critera4 + form.critera5 + form.critera6 + form.critera7 + form.critera8 + form.critera9 + form.critera10 + form.critera11
        self.hasScore = true
        return String(result)
      } */
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/Hestia.vue